import { render, staticRenderFns } from "./CurationFilterLink.vue?vue&type=template&id=74482b55&scoped=true&"
import script from "./CurationFilterLink.vue?vue&type=script&lang=js&"
export * from "./CurationFilterLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74482b55",
  null
  
)

export default component.exports